export default "__VITE_ASSET__C3tBhM5h__"